import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import { toHttpParams, snakeCase, toCamelcase, createNamedApi, combineEffectsWithProviders } from '@essent/common';
import * as i1$1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';
import * as i1 from '@angular/common/http';

/**
 * @ignore
 */
const API = new InjectionToken('api-feh');

class GetCheckPostcodeService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/feh/postcode/v${this.apiVersion}`;
    }
    call$(payload) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase(payload));
        return this.httpClient.get(this.endpoint, { params, headers }).pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetCheckPostcodeService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetCheckPostcodeService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetCheckPostcodeService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const getCheckPostcodeApi = createNamedApi('[FehState] Get check postcode', GetCheckPostcodeService);

class PostCreateLeadThirdPartyService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/eplus/leads/third-party/v${this.apiVersion}`;
    }
    call$(payload) {
        const headers = { Accept: 'application/json' };
        return this.httpClient.post(this.endpoint, snakeCase(payload), { headers }).pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: PostCreateLeadThirdPartyService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: PostCreateLeadThirdPartyService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: PostCreateLeadThirdPartyService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const postCreateLeadThirdPartyApi = createNamedApi('[FehState] Post create lead third party', PostCreateLeadThirdPartyService);

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getCheckPostcodeApi, postCreateLeadThirdPartyApi);
class FehModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('FehModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: FehModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: FehModule, deps: [{ token: FehModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: FehModule, imports: [i1$1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: FehModule, providers: [PROVIDERS], imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: FehModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: [PROVIDERS]
                }]
        }], ctorParameters: () => [{ type: FehModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getCheckPostcodeActions, getCheckPostcode, getCheckPostcodeSuccess, getCheckPostcodeError, getCheckPostcodeClear } = getCheckPostcodeApi;

const { postCreateLeadThirdPartyActions, postCreateLeadThirdParty, postCreateLeadThirdPartySuccess, postCreateLeadThirdPartyError, postCreateLeadThirdPartyClear } = postCreateLeadThirdPartyApi;

var LeadContractType;
(function (LeadContractType) {
    LeadContractType["RENT"] = "Huur";
    LeadContractType["BUY"] = "Koop";
    LeadContractType["BUY_AND_RENT"] = "Koop en Huur";
})(LeadContractType || (LeadContractType = {}));
var ProductTypeThirdParty;
(function (ProductTypeThirdParty) {
    ProductTypeThirdParty["Zon"] = "Zon";
    ProductTypeThirdParty["CV"] = "CV";
    ProductTypeThirdParty["Isolatie"] = "Isolatie";
    ProductTypeThirdParty["Ventilatie"] = "Ventilatie";
    ProductTypeThirdParty["SenO"] = "SenO";
    ProductTypeThirdParty["ESCO"] = "ESCO";
    ProductTypeThirdParty["Comfort Algemeen"] = "Comfort Algemeen";
    ProductTypeThirdParty["Zonneboiler"] = "Zonneboiler";
    ProductTypeThirdParty["ZoOpgelost"] = "ZoOpgelost";
    ProductTypeThirdParty["SlimmeVerlichting"] = "SlimmeVerlichting";
    ProductTypeThirdParty["Nest"] = "Nest";
    ProductTypeThirdParty["LyricT6"] = "LyricT6";
    ProductTypeThirdParty["RoundConnected"] = "RoundConnected";
    ProductTypeThirdParty["Energielabel"] = "Energielabel";
    ProductTypeThirdParty["Warmtepomp"] = "Warmtepomp";
    ProductTypeThirdParty["Bespaaradvies"] = "Bespaaradvies";
    ProductTypeThirdParty["Eenmalig Onderhoud CV"] = "Eenmalig Onderhoud CV";
    ProductTypeThirdParty["Zon ED"] = "Zon ED";
    ProductTypeThirdParty["SenO CVTotaal"] = "SenO CVTotaal";
    ProductTypeThirdParty["NestProtect"] = "NestProtect";
    ProductTypeThirdParty["Nest_E"] = "Nest_E";
    ProductTypeThirdParty["Safety Security"] = "Safety Security";
    ProductTypeThirdParty["IsolatieED"] = "IsolatieED";
    ProductTypeThirdParty["Ontbreekt"] = "Ontbreekt";
    ProductTypeThirdParty["IsolatieGlas"] = "IsolatieGlas";
    ProductTypeThirdParty["Zon_VDB"] = "Zon_VDB";
    ProductTypeThirdParty["Isolatie_VDB"] = "Isolatie_VDB";
    ProductTypeThirdParty["Advies"] = "Advies";
    ProductTypeThirdParty["Ventilatie_reiniging"] = "Ventilatie_reiniging";
    ProductTypeThirdParty["Ventilatie_combinatie"] = "Ventilatie_combinatie";
    ProductTypeThirdParty["EFS_SME"] = "EFS_SME";
    ProductTypeThirdParty["Zon_SME"] = "Zon_SME";
    ProductTypeThirdParty["Led_SME"] = "Led_SME";
    ProductTypeThirdParty["Heating_SME"] = "Heating_SME";
    ProductTypeThirdParty["Isolatie_SME"] = "Isolatie_SME";
    ProductTypeThirdParty["Energielabel_SME"] = "Energielabel_SME";
    ProductTypeThirdParty["Dakvrienden_SME"] = "Dakvrienden_SME";
    ProductTypeThirdParty["ZonHof_SME"] = "ZonHof_SME";
    ProductTypeThirdParty["Emobility"] = "Emobility";
    ProductTypeThirdParty["EIS"] = "EIS";
    ProductTypeThirdParty["Power"] = "Power";
    ProductTypeThirdParty["SME_Winactie"] = "SME_Winactie";
    ProductTypeThirdParty["IR-Paneel"] = "IR-Paneel";
    ProductTypeThirdParty["Waterstof"] = "Waterstof";
    ProductTypeThirdParty["Dakisolatie"] = "Dakisolatie";
    ProductTypeThirdParty["Spouwmuurisolatie"] = "Spouwmuurisolatie";
    ProductTypeThirdParty["Vloerisolatie"] = "Vloerisolatie";
    ProductTypeThirdParty["Herisolatie"] = "Herisolatie";
    ProductTypeThirdParty["Thuisbatterij"] = "Thuisbatterij";
    ProductTypeThirdParty["Laadpaal"] = "Laadpaal";
    ProductTypeThirdParty["Laaddruppel"] = "Laaddruppel";
    ProductTypeThirdParty["Laadpas"] = "Laadpas";
})(ProductTypeThirdParty || (ProductTypeThirdParty = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { API, FehModule, GetCheckPostcodeService, PostCreateLeadThirdPartyService, ProductTypeThirdParty, getCheckPostcode, getCheckPostcodeActions, getCheckPostcodeClear, getCheckPostcodeError, getCheckPostcodeSuccess, postCreateLeadThirdParty, postCreateLeadThirdPartyActions, postCreateLeadThirdPartyClear, postCreateLeadThirdPartyError, postCreateLeadThirdPartySuccess };
